export function fixTruncatedValue(value: number, isM2: boolean = false): number {
  if (!value || value <= 0) return value;

  if (isM2) {
    if (value < 100) {
      return value * 1000;
    }
  } else {
    if (value < 50000) {
      return value * 1000;
    }
  }

  return value;
}

export function parseAndFixCurrencyValue(valorStr: string, isM2: boolean = false): number {
  if (!valorStr) return 0;

  let cleanValue = valorStr.replace('R$ ', '').replace('R$', '').trim();

  const hasComma = cleanValue.includes(',');
  const hasDot = cleanValue.includes('.');

  if (hasComma && hasDot) {
    cleanValue = cleanValue.replace(/\./g, '').replace(',', '.');
  } else if (hasComma && !hasDot) {
    cleanValue = cleanValue.replace(',', '.');
  }
  const numValue = parseFloat(cleanValue) || 0;

  return fixTruncatedValue(numValue, isM2);
}

export function fixCurrencyString(valorStr: string, isM2: boolean = false): string {
  if (!valorStr || typeof valorStr !== 'string') return valorStr;

  const numValue = parseAndFixCurrencyValue(valorStr, isM2);

  return `R$ ${numValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
